import { MembershipTypeSaleInfoModel } from '../../tsrestapi/models';
import { StateCreatorWithDevtools } from '../store-utils';

// INFO: New sale

export interface MembershipStoreSlice {
    
    membershipTypeSavingAmounts: MembershipTypeSaleInfoModel[],
    setMembershipTypeSavingAmounts: (membershipTypeSavingAmounts: MembershipTypeSaleInfoModel[]) => void,

}

export const MembershipStoreSliceDef: StateCreatorWithDevtools<MembershipStoreSlice, MembershipStoreSlice> = (set, get) => {
    return {
        membershipTypeSavingAmounts: [],
        setMembershipTypeSavingAmounts: (membershipTypeSavingAmounts: MembershipTypeSaleInfoModel[]) => set({ membershipTypeSavingAmounts }, false, "membershipTypeSavingAmounts"),
    };
};

